import React, { Component } from 'react';
import { connect } from 'dva';
import moment from 'moment';
// eslint-disable-next-line import/no-extraneous-dependencies
import router from 'umi/router';
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Tooltip,
  Modal,
  message,
  Cascader,
  DatePicker,
  Select,
  Popconfirm,
  Icon,
  Spin
} from 'antd';
import SelectUserRange from 'nbugs-select-user-range-v4.0';
import OperateDropdown from '../../../../components/OperateDropdown';
import ListPage from '../../../../components/ListPage';
import Container from '../../../../components/Container';
import TreeSelectChannel from '../ArticlePublished/components/TreeSelectChannel';
import { getAppCode } from '../utils/utils';
import { convertData, getDefaultData, getLabelStrData } from '../utils/convertData';
import { getPathHeader } from '../../../../utils/utils';
import AdjustOrder from './components/AdjustOrder'
import styles from './index.less';


const { RangePicker } = DatePicker;

const { ListTable } = ListPage;
const { Option } = Select;
const { confirm } = Modal;

const defaultDate = moment().format('YYYY-MM-DD');
const defaultDateStart = moment()
  .add(-6, 'M')
  .format('YYYY-MM-DD');
@Form.create()
@connect(({ user, courseManage }) => {
  return {
    orgId: user.currentUser.orgId,
    ...courseManage,
  };
})
class MatterManage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      dataSource: [],
      channelList: [],
      loading: false,
      totalElements: 0,
      visible: false,
      selectChannelId: [],
      selectRcord: {},
      alreadyPushList: {},
      params: {
        title: '',
        appCode: getAppCode(),
        page: 1,
        pageSize: 10,
        channelId: '',
        labelId: 0,
        startDay: defaultDateStart,
        endDay: defaultDate,
        newsTypes: '3,4',
      },
      channelId: '0',
      treeChannelData: [],
      labelList: [],

      selectModalVisible: false,
      selectSignature: '',
      currentPushId: '',
      setOrder: false,
    };
  }

  componentDidMount() {
    const { params } = this.state;
    this.setColumns();
    this.fetchChannelList();
    this.fetchNewsManagerList(params);
    this.fetchLabelList();
  }

  // 获取标签列表
  fetchLabelList = () => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'courseManage/fetchLabelList',
      params: { appCode: getAppCode() },
    })
      .then(res => {
        const arr = [];
        (res || []).forEach(item => {
          arr.push({ ...item, checked: false });
        });
        this.setState({ labelList: arr, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  search = e => {
    e.preventDefault();
    const { form } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { params, channelId } = this.state;
        const rangeValue = values['range-picker'];
        const tempParams = {
          ...params,
          title: values.title ? encodeURIComponent(values.title) : '',
          channelId,
          labelId: values.labelId,
          startDay: rangeValue && rangeValue[0] ? rangeValue[0].format('YYYY-MM-DD') : defaultDate,
          endDay: rangeValue && rangeValue[1] ? rangeValue[1].format('YYYY-MM-DD') : defaultDate,
          page: 1,
        };
        this.setState({
          params: tempParams,
        });
        this.fetchNewsManagerList(tempParams);
      }
    });
  };

  reSet = () => {
    const { form } = this.props;
    form.resetFields();
    const { params, channelId } = this.state;
    const tempParams = {
      ...params,
      title: '',
      labelId: 0,
      channelId,
      page: 1,
      startDay: defaultDate,
      endDay: defaultDate,
    };
    this.setState({
      params: tempParams,
    });
    this.fetchNewsManagerList(tempParams);
  };

  fetchNewsManagerList = params => {
    const { dispatch } = this.props;
    const { alreadyPushList } = this.state;
    this.setState({ loading: true });
    dispatch({
      type: 'courseManage/fetchNewsManagerList',
      params,
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: getLabelStrData(res, alreadyPushList),
          totalElements: res.totalElements,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  // fetchNewsTop = (record, toTop) => {
  //   const { dispatch } = this.props;
  //   this.setState({ loading: true });
  //   dispatch({
  //     type: 'courseManage/fetchNewsTop',
  //     params: {
  //       id: record.id,
  //       toTop,
  //       appCode: getAppCode(),
  //     },
  //   })
  //     .then(() => {
  //       this.setState({ loading: false });
  //       const { params } = this.state;
  //       this.fetchNewsManagerList(params);
  //     })
  //     .catch(() => {
  //       this.setState({ loading: false });
  //     });
  // };

  fetchChannelList = () => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'courseManage/fetchChannelList',
      params: { appCode: getAppCode() },
    })
      .then(res => {
        const data = [{ value: 0, label: '全部栏目', children: convertData(res || []) }];
        const channelList = convertData(res || []);
        channelList.unshift({ value: 0, label: '全部', children: [] });
        this.setState({
          channelList,
          treeChannelData: data,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchNewsRemove = record => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'courseManage/fetchNewsRemove',
      params: { id: record.id, appCode: getAppCode() },
    })
      .then(() => {
        this.setState({ loading: false });
        message.success('删除成功');
        const { params } = this.state;
        this.fetchNewsManagerList(params);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  setColumns = () => {
    const columns = [
      {
        title: '主题',
        dataIndex: 'title',
        key: 'title',
        width: 400,
        fixed: 'left',
        render: text => {
          if (text?.length <= 20) {
            return <span>{text}</span>;
          }
          return (
            <Tooltip placement="top" title={text}>
              <span>{text.substring(0, 20)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '类型',
        dataIndex: 'newstype',
        key: 'newstype',
        width: 150,
        // eslint-disable-next-line consistent-return
        render: text => {
          if (Number(text) === 3) {
            return '独立课程';
          }
          if (Number(text) === 4) {
            return '章节课程';
          }
        },
      },
      {
        title: '子课程数',
        dataIndex: 'newsInfoList',
        key: 'newsInfoList',
        width: 150,
        render: text => {
          return <span>{text.length || 0}</span>;
        },
      },
      {
        title: '创建时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: text => {
          return <span>{moment(text).format('YYYY.MM.DD HH:mm')}</span>;
        },
      },
      {
        title: '完成人数',
        dataIndex: 'courseCount',
        key: 'courseCount',
        width: 150,
      },
      {
        title: '学习情况',
        dataIndex: 'newstype',
        key: 'newstype',
        render: (text, record) => {
          return (
            <a
              onClick={e => {
                e.stopPropagation();
                router.push(
                  `/${getPathHeader()}/course/manage/study?appCode=${getAppCode()}&id=${record.id
                  }&title=${record.title}`
                );
              }}
            >
              查看
            </a>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 160,
        fixed: 'right',
        render: (text, record) => {
          const data = [
            {
              text: (
                <a
                  onClick={e => {
                    e.stopPropagation();
                    router.push(
                      `/${getPathHeader()}/course/manage/${Number(record.newstype) === 4
                        ? 'createChapterCourse'
                        : 'createIndependentCourse'
                      }?id=${record.id}&appCode=${getAppCode()}`
                    );
                  }}
                >
                  编辑
                </a>
              ),
            },
            // {
            //   text:
            //     record.stayonTop === 0 ? (
            //       <a onClick={() => this.fetchNewsTop(record, 1)}>置顶</a>
            //     ) : (
            //         <a onClick={() => this.fetchNewsTop(record, 0)}>取消置顶</a>
            //       ),
            // },

            {
              text: <a onClick={() => this.movement(record)}>移动栏目</a>,
            },
            // {
            //   text: (
            //     <a
            //       onClick={() =>
            //         this.setState({
            //           currentPushId: record.id,
            //           selectModalVisible: true,
            //         })
            //       }
            //     >
            //       推送
            //     </a>
            //   ),
            // },
            {
              text: (
                <Popconfirm
                  title="确认删除？"
                  okText="确认"
                  cancelText="取消"
                  onConfirm={() => this.fetchNewsRemove(record)}
                >
                  <a>删除</a>
                </Popconfirm>
              ),
            },
          ];
          const newData = [];
          data.forEach(item => {
            if (item.text) {
              newData.push(item);
            }
          });
          return <OperateDropdown data={newData} />;
        },
      },
    ];

    this.setState({ columns });
  };

  setChannelId = id => {
    const { params } = this.state;
    this.setState({ channelId: id, params: { ...params, page: 1, channelId: id } });
  };

  changePage = (page, pageSize) => {
    const { params, channelId } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
      channelId: channelId === '0' ? '' : channelId,
    };
    this.setState({ params: tempParams });
    this.fetchNewsManagerList(tempParams);
  };

  movement = record => {
    if (!record.channel) {
      message.error('系统栏目的课程不能移动');
      return;
    }
    const { channelList } = this.state;
    this.setState(
      {
        selectChannelId: getDefaultData(channelList, record.channel.id),
        selectRcord: record,
      },
      () => {
        this.setState({ visible: true });
      }
    );
  };

  handleMoveOk = () => {
    const { selectChannelId, selectRcord } = this.state;

    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'courseManage/fetchNewsMovement',
      params: {
        toChanneldId: selectChannelId[selectChannelId.length - 1],
        ids: selectRcord.id,
      },
    })
      .then(() => {
        this.setState({ loading: false, visible: false });
        const { params } = this.state;
        this.fetchNewsManagerList(params);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleChange = value => {
    this.setState({ selectChannelId: value });
  };

  handleCancel = () => {
    this.setState({
      selectModalVisible: false,
      selectSignature: '',
    });
  };

  handleOk = () => {
    const { selectSignature, currentPushId } = this.state;
    const { dispatch } = this.props;
    const that = this;
    this.setState(
      {
        selectModalVisible: false,
      },
      () => {
        confirm({
          title: '确定推送吗',
          content: '',
          okText: '确定',
          cancelText: '取消',
          className: styles.confirmModal,
          onOk() {
            dispatch({
              type: 'courseManage/fetchPushNews',
              params: {
                id: currentPushId,
                appCode: getAppCode(),
                selectId: selectSignature,
                selectIdType: 2,
              },
            }).then(() => {
              message.success('推送成功');
              that.setState({
                selectSignature: '',
                currentPushId: '',
              });
            });
          },
          onCancel() {
            console.log('Cancel');
          },
        });
      }
    );
  };

  saveSelectSignature = data => {
    const { selectSignature, groupInfoList = [], orgRelInfoList = [], tagInfoList = [] } = data;

    const orgArr = [...groupInfoList, ...orgRelInfoList];

    if (orgArr.length > 0 && tagInfoList.length > 0) {
      this.setState({
        selectSignature,
      });
    } else {
      this.setState({
        selectSignature: '',
      });
    }
  };

  refreshData = () => {
    const { params } = this.state
    this.fetchNewsManagerList(params);
  }

  render() {
    const {
      columns,
      loading,
      dataSource,
      params,
      totalElements,
      channelList = [],
      visible,
      selectChannelId,
      treeChannelData,
      labelList,
      selectModalVisible,
      selectSignature,
      setOrder,
      channelId
    } = this.state;
    const { page } = params;
    const { form } = this.props;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
    };

    const pageProps = {
      spinProps: { spinning: loading },
      className: styles.root,
    };

    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      onPageChange: this.changePage,
    };

    const selectUserRangeProps = {
      tagProps: {
        subtitle: '已选对象',
        btnText: '选择',
        btnDetele: true,
      },
      orgRelProps: {
        subtitle: '已选对象',
        btnText: '选择',
        btnDetele: true,
        showTabList: ['orgRel'],
        requestParams: {
          selectTypeList: ['org_rel'],
        },
      },
      title: '推送范围',
      funCallbackSignature: data => this.saveSelectSignature(data),
    };


    return (
      <Container breStates isSplitBar>
        <ListPage {...pageProps}>
          <Row className={styles['search-area']}>
            <Col span={8}>
              <Form.Item {...formItemLayout} label="主题">
                {getFieldDecorator('title', {
                  rules: [
                    {
                      max: 50,
                      message: '请勿超过50个字!',
                    },
                  ],
                })(<Input placeholder="请输入素材名称" onPressEnter={this.search} />)}
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item label="时间" {...formItemLayout}>
                {getFieldDecorator(`range-picker`, {
                  initialValue: [
                    moment(moment().add(-6, 'M'), 'YYYY.MM.DD'),
                    moment(new Date(), 'YYYY.MM.DD'),
                  ],
                })(<RangePicker format="YYYY.MM.DD" placeholder={['请选择', '请选择']} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...formItemLayout} label="标签">
                {getFieldDecorator('labelId', {
                  initialValue: 0,
                })(
                  <Select>
                    <Option value={0}>全部</Option>
                    {labelList.map(item => {
                      return <Option value={item.id}>{item.label}</Option>;
                    })}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col
              span={8}
              offset={16}
              style={{ textAlign: 'right', paddingRight: 24, marginTop: 10 }}
            >
              <Form.Item>
                <Button type="primary" onClick={this.search}>
                  查询
                </Button>
                <Button onClick={this.reSet}>重置</Button>
              </Form.Item>
            </Col>
          </Row>
          <Button
            type="primary"
            onClick={() =>
              router.push(
                `/${getPathHeader()}/course/manage/createIndependentCourse?appCode=${getAppCode()}`
              )
            }
          >
            开设独立课程
          </Button>
          <Button
            onClick={() =>
              router.push(
                `/${getPathHeader()}/course/manage/createChapterCourse?appCode=${getAppCode()}`
              )
            }
          >
            开设章节课程
          </Button>
          <Button
            onClick={() =>
              router.push(
                `/${getPathHeader()}/course/manage/push?appCode=${getAppCode()}`
              )
            }
          >
            推送
          </Button>
          <Button
            onClick={() =>
              this.setState({ setOrder: true })
            }
          >
            调整顺序
          </Button>
          <section className="table-area">
            <div>
              <TreeSelectChannel
                channelList={treeChannelData}
                params={params}
                fetchPublishList={this.fetchNewsManagerList}
                setChannelId={this.setChannelId}
              />
            </div>
            <div>
              <ListTable {...tableProps} />
            </div>
          </section>
          <Modal
            title="移动到其他栏目"
            centered
            visible={visible}
            onOk={this.handleMoveOk}
            onCancel={() => this.setState({ visible: false })}
          >
            <Cascader
              style={{ width: '100%' }}
              onChange={this.handleChange}
              options={channelList}
              defaultValue={selectChannelId}
              value={selectChannelId}
              placeholder="请选择发布的栏目"
            />
          </Modal>
          {selectModalVisible && (
            <Modal
              title="选择对象"
              width={931}
              wrapClassName="nbugs-select-user-range-modal"
              visible={selectModalVisible}
              onCancel={this.handleCancel}
              footer={[
                <Button onClick={this.handleCancel}>取消</Button>,
                <Button type="primary" onClick={this.handleOk} disabled={!selectSignature.length}>
                  确定
                </Button>,
              ]}
            >
              <div className="content">
                <p>
                  <span style={{ color: '#F5222D' }}>*</span>系统标签内组织精准推送
                  <Tooltip
                    placement="top"
                    title="从已有系统标签规则选择组织精准推送"
                    autoAdjustOverflow
                  >
                    <Icon type="question-circle" />:
                  </Tooltip>
                </p>
                <SelectUserRange {...selectUserRangeProps} />
              </div>
            </Modal>
          )}
          {
            setOrder && <AdjustOrder
              visible={setOrder}
              startDay={params.startDay}
              endDay={params.endDay}
              channelId={channelId}
              close={() => this.setState({ setOrder: false })}
              refreshData={this.refreshData}
            />

          }
        </ListPage>
      </Container>
    );
  }
}

export default MatterManage;
